export default {
  visa: {
    name: 'Visa',
    icon: 'visa',
  },
  mastercard: {
    name: 'Mastercard',
    icon: 'mastercard',
  },
  amex: {
    name: 'American Express',
    icon: 'amex',
  },
  diners: {
    name: 'Diners Club',
    icon: 'diners',
  },
  discover: {
    name: 'Discover',
    icon: 'discover',
  },
  jcb: {
    name: 'JCB',
    icon: 'jcb',
  },
  unionpay: {
    name: 'UnionPay',
    icon: 'unionpay',
  },
  mada: {
    name: 'Mada',
    icon: 'mada',
  },
  mir: {
    name: 'Mir',
    icon: 'mir',
  },
  elo: {
    name: 'Elo',
    icon: 'elo',
  },
  hiper: {
    name: 'Hiper',
    icon: 'hiper',
  },
  hipercard: {
    name: 'Hipercard',
    icon: 'hipercard',
  },
  defult: {
    name: 'Default',
    icon: 'default',
  },
};

export const backend_to_cleave_type = {
  visa: 'visa',
  american_express: 'amex',
  "american express": 'amex',
  master: 'mastercard',
  diners_club: 'diners',
  discover: 'discover',
  jcb: 'jcb',
  unionpay: 'unionpay',
  mada: 'mada',
  mir: 'mir',
  elo: 'elo',
  hiper: 'hiper',
  hipercard: 'hipercard',
};

